import React, {useEffect, useRef, useState} from 'react';
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import { connect } from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import HarborLangs from "./_langs";
import { showLoader } from "../../../components/loader/loader";
import {
	ButtonCancel,
	ButtonEdit,
	ButtonNew,
	ButtonSubmit,
	GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {
	FORM,
	INTERNATIONAL,
	LB_ACTIVE,
	LB_CODE,
	LB_LATITUD,
	LB_LONGITUD,
	REQUIRED
} from "../../../components/i18n/i18n";

import {setFormInfo, setEnabledForm, setDataToEdit, setEditMode} from '../../../redux/actions/genericActions'
import { saveHarbor, updateHarbor } from "../../../redux/actions/harborActions";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import Switch from "react-bootstrap-switch";
import {FL_IMAGE, FL_ORDER} from "../../../components/i18n/formLabels";
import TranslatedLangs from "../../../components/genericComponents/TranslatedLangs";

const HarborForm = props => {
	const fbDataBaseId = props?.app?.fbDataBase?.id
	const { dataToEdit, editMode, loading, disableInputs, saveSuccess } = props.harborInfo
	const [status, setStatus] = useState( dataToEdit?.status || false)
	const [showModal, setShowModal] = useState(true)
	const modalRef = useRef(null);
	const translatableLangs = dataToEdit?.translatedLangs || []

	const showHistory = () => {
		setShowModal(true);
		modalRef.current.showModal(dataToEdit);
	}

	useEffect(() => {
		return () => props.setEnabledForm(true)
	},[])

	const validationSchema = Yup.object().shape({
		code: Yup.string().required( REQUIRED )
	});

	const { register, handleSubmit, reset, errors } = useForm({
		validationSchema: validationSchema,
		defaultValues: {
			id: dataToEdit?.id,
			uid: dataToEdit?.uid,
			code: dataToEdit?.code,
			name: dataToEdit?.name,
			image: dataToEdit?.image,
			showOrder: dataToEdit?.showOrder,
			latitude: dataToEdit?.latitude,
			longitude: dataToEdit?.longitude,
		}
	});

	const onSubmit = (data, _) => {
		const requestData = {
			fbDataBase:  { id : fbDataBaseId },
			item: {
				...data,
				status: status,
				latitude: Number(data.latitude),
				longitude: Number(data.longitude),
				langs: props.harborInfo?.dataToEdit?.langs
			}
		};

		if (editMode)
			requestData.item.id = dataToEdit?.id

		if (!editMode)
			return props.saveHarbor(requestData)
		else {
			let id = dataToEdit.id;
			requestData.item.id = dataToEdit?.id

			return props.updateHarbor(id, requestData)
		}
	};

	const resetForm = () => {
		props.setDataToEdit(null)
		props.setEnabledForm( true )
		props.setEditMode(false)
		reset();
	}

	const beginEdit = () => {
		props.setEnabledForm(true)
		props.setEditMode(true)
	}

	const setForm = () => props.setFormInfo(null, null, 'LIST');

	return (<Card>
		{ loading ? showLoader() : null }
		<CardTitle className="bg-light border-bottom p-3 mb-0">
			<i className="far fa-edit mr-2"/>{FORM}
			{
				editMode && <div className="float-right">
					<GenericTableButton
						toolTip={TT_HISTORY}
						icon={'fa-clock'}
						permission={'search'}
						onClick={showHistory}
					/>
				</div>
			}
		</CardTitle>
		<CardBody>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Row>
					<Col md="3">
						<FormGroup>
							<Label>{LB_CODE}</Label>
							<Input type="text" name="code"
								   placeholder="Codigo"
								   innerRef={register}
								   className={(errors.code ? ' is-invalid' : '')}
							/>
							{ errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div> }
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label>{ FL_IMAGE }</Label>
							<Input type="text" name="image"
								   placeholder="Ingrese imagen"
								   innerRef={register}
								   disabled={disableInputs}/>
						</FormGroup>
					</Col>
					<Col md="2">
						<FormGroup>
							<Label>{ FL_ORDER }</Label>
							<Input type="number"
								   name="showOrder"
								   innerRef={register}
								   className={(errors.description ? ' is-invalid' : '')}
							/>
							<ErrorMessage errors={errors} name="color" component="div"
										  className="invalid-feedback"/>
						</FormGroup>
					</Col>
					<Col md="2">
						<FormGroup>
							<Label>{LB_ACTIVE}</Label>
							<br/>
							<Switch
								animate={true}
								offText={"No"}
								onText={"Si"}
								value={ status }
								disabled={ disableInputs }
								onChange={ _ => setStatus(!status) }
							/>

						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md="3">
						<FormGroup>
							<Label>{LB_LATITUD}</Label>
							<Input type="number" name="latitude"
								   placeholder="000.000"
								   step="0.00001"
								   innerRef={register}
								   disabled={disableInputs}/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label>{LB_LONGITUD}</Label>
							<Input type="number" name="longitude"
								   placeholder="000.000"
								   step="0.00001"
								   innerRef={register}
								   disabled={disableInputs}/>
						</FormGroup>
					</Col>
				</Row>
				<CardTitle className="bg-light border-bottom p-3 mb-0">
					<i className="fas fa-language mr-2"/>{INTERNATIONAL}
				</CardTitle>
				<CardBody>
					<TranslatedLangs translatableLangs={translatableLangs} />
					<HarborLangs />
				</CardBody>
				<CardBody className="border-top">
					{
						saveSuccess ?
							<div className="float-right">
								<ButtonNew onClick={ resetForm }/>
								<ButtonEdit onClick={ beginEdit }/>
								<ButtonCancel onClick={ setForm }/>
							</div>
							: <div className="float-right">
								<ButtonSubmit/>
								<ButtonCancel onClick={ setForm }/>
							</div>
					}
				</CardBody>
			</Form>
		</CardBody>
		{
			showModal && <LogHistoryModal
				ref={ modalRef }
				item={ dataToEdit }
			/>
		}
	</Card>)
}

const mapStateToProps = state => ({
	harborInfo: state.genericInfo,
})

const mapActionsToProps = ({
	setFormInfo,
	setDataToEdit,
	setEnabledForm,
	setEditMode,
	saveHarbor,
	updateHarbor,
})

export default connect(mapStateToProps, mapActionsToProps )(HarborForm)